import { defineMessages } from "react-intl";

const SECRET_QUESTION_UPDATE_PAGE = "secret-question-update-page";

const secretQuestionUpdatePageMessages = defineMessages({
  changeMySecretQuestion: {
    id: `${SECRET_QUESTION_UPDATE_PAGE}.change-my-secret-question`,
    defaultMessage: "Change my secret question",
    description: "Title for page to update the secret question"
  }
});

export default secretQuestionUpdatePageMessages;
